import React from 'react';
import Page from "../Page";
import $ from "jquery";
import { notify } from "react-notify-toast";
import { Link } from "react-router-dom";
import {
	Row,
	Col,
	Modal,
	Button,
   Preloader
} from "react-materialize";

import Waypoint from "react-waypoint";
import { API_REF_CASH,API_TOTAL_POINT,API_REDEEM_CASH,QueryParam,API_IS_REFERRAL,API_CEK_PELANGGAN,API_CEK_ACCOUNT, API_BASE_URL } from "../Util";

class DetailBenefit extends Page {
   static LIMIT = 10;
   constructor(props){
      super(props);
      let params = QueryParam();

      this.state = {
         status_referral:"", 
         params: params, 
         offset: 0, 
         end: false,
         total_benefit:"",
         total_point:"",
         total_bonus:"",
         total_pengguna:"",
         redeem_pulsa:[],
         total_redeem:"",
         point_redeem:"",
         sudah_terkirim:"",
         belum_terkirim:"",
         belum_terkirim_redeem:"",
         sisa_point:"",
         status_redeem:"",
         sisa_redeem:"",
         message_redeem:"",
         cek_akun:"",
         pelanggan:[]
		};
   }

   componentDidMount(){
      this.handleIsReferral()
      this.handleTotalBonus()
      this.handleRefCash()
      this.handleLoadData()
      this.handleCekAccount()
   }

   handleIsReferral(){
		$.get(API_IS_REFERRAL).then(data => {
			console.log('isReferral', data.payload)
			this.setState({status_referral : data.status});
         if (this.state.status_referral != true){
            this.props.history.push("/")
         }
		})
	}

   handleCekAccount(){
      $.get(API_CEK_ACCOUNT).then(data => {
         this.setState({cek_akun : data.status})
         console.log('cek account', this.state.cek_akun);
      })
   }

   toggleLoading(on) {
		if (on) {
			$(".load-more").show();
		} else {
			$(".load-more").hide();
		}
	}

   _loadMoreContent = e => {
      console.log('load1', this.state.end);
		if (this.state.end) {
			this.handleLoadData();
		}
	};

   handleLoadData = async (params) =>{
      let list_pengguna = []
      if (!params) {
			params = this.state.params;
		}
		params["limit"] = DetailBenefit.LIMIT;

		params["offset"] = this.state.offset;
      console.log('offset',!params['offset']);

      this.toggleLoading(1);
      $.get(API_CEK_PELANGGAN, params).then(data => {
         for (let i = 0; i <= data.data.length; i++)
         {
            console.log('pelanggan',data.data[i].pengguna.name)
            let list = data.data[i].pengguna.name
            list_pengguna.push(list)
            console.log('pelanggan2',list_pengguna)
            
            console.log('offset',params['offset'])
            if (!params["offset"]) {
               var list1 = list_pengguna;
            } else {
               var list1 = this.state.pelanggan;
               list1.push(...list_pengguna);
            }   
            console.log('list1', list1.length)
            if (
               list1.length == 0 ||
               list1.length < DetailBenefit.LIMIT
               ) {
                  this.setState({ end: true });
                  console.log('end1', this.state.end);
               }
               this.setState({
                  pelanggan : list1,
                  offset: params["offset"] + DetailBenefit.LIMIT
            });
            this.toggleLoading();
         }
      })
   }
   
   handleRefCash(){
      $.get(API_REF_CASH).then(data =>{
         console.log('pulsa', data.data)
         this.setState({redeem_pulsa: data.data});
      })
   }

   handlePulsaChange = e => {
      let {name, value} = e.target
      if (name == "pulsa"){
         this.setState({total_redeem: value})
      }
   }
   
   handleSubmitPulsa = (e) => {
      e.preventDefault();
      let {total_redeem} = this.state
     $.post(API_REDEEM_CASH, {total_redeem}).then(data =>{
       console.log('redeem', data)
       this.setState({
          point_redeem: data.data.total_redeem, 
          sisa_redeem: data.data.sisa, 
          status_redeem: data.status, 
          message_redeem: data.message,
          belum_terkirim_redeem: data.data.belum_dikirm
         })
         if(data.status != false){
            $(".modal-overlay").trigger("click")
          }
     })
   }

   handleTotalBonus(){
      $.get(API_TOTAL_POINT).then(data => {
         console.log('total_benefit', data.data)
         this.setState({
            total_benefit: data.data.total_benefit,
            total_point: data.data.total_point,
            total_bonus: data.data.total_bonus,
            total_pengguna: data.data.total_pengguna,
            belum_terkirim: data.data.belum_dikirim,
            sudah_terkirim: data.data.berhasil_dikirim,
            sisa_point: data.data.sisa_point
         })
      })
   }

   render(){
      let {
         total_benefit,
         total_point,
         total_bonus, 
         total_pengguna, 
         redeem_pulsa, 
         point_redeem,
         belum_terkirim,
         belum_terkirim_redeem,
         sudah_terkirim,
         sisa_point,
         status_redeem,
         message_redeem,
         sisa_redeem,
         cek_akun,
         list
      } = this.state;

      return (
         <div className="bg-white no-shadow container pad-m ">
            <div className="nav-wrapper">
               {/* <Row>
                  <Col className="col s12">
                     <Collapsible className="modules-collapsible">
                        <CollapsibleItem
                           header="Semua Tanggal"
                           icon="keyboard_arrow_up" 
                        >
                           <Collection>
                              <CollectionItem>
                                 
                              </CollectionItem>
                           </Collection>
                        </CollapsibleItem>
                     </Collapsible>
                  </Col>
               </Row> */}
               <Row style={{display: 'flex'}} className="mt-l">
                  <Col className="col s3">
                     <img src="img/geti-detail.png" alt="" />
                  </Col>
                  <Col className="col s9 ml-l" style={{marginLeft:"20px"}}>
                     <h4 style={{marginBottom:"0px"}}>TOTAL BENEFIT</h4>
                     <h2 style={{marginTop:"0px", color:"#4a65d8"}}>Rp {total_point}</h2>
                  </Col>
               </Row>
               <Row style={{display:"flex", marginBottom:"15px"}}>
                  <Col style={{marginLeft:"0px", width:"20%", borderRight:"2px solid #0559f3"}} className="col s2">
                     <p style={{marginTop:"0px"}}>Pengguna Kode</p>
                     <h5 style={{ color:"#4a65d8"}}>{total_pengguna} Orang</h5>
                  </Col>
                  {/* <Col style={{marginLeft:"20px",width:"20%", borderRight:"2px solid #0559f3"}} className="col s2">
                     <p style={{marginTop:"0px"}}>Jumlah Benefit</p>
                     <h5 style={{color:"#4a65d8"}}>Rp {total_benefit}</h5>
                  </Col> */}
                  {/* {
                     sisa_point != 0 ?
                        <Col style={{marginLeft:"20px",width:"20%", borderRight:"2px solid #45f79e"}} className="col s2">
                           <p style={{marginTop:"0px"}}>Jumlah Bonus</p>
                           <h5 style={{ color:"#4a65d8"}}>Rp {total_bonus}</h5>
                        </Col>
                        :
                        <Col style={{marginLeft:"20px",width:"20%", borderRight:"2px solid red"}} className="col s2">
                           <p style={{marginTop:"0px"}}>Jumlah Bonus</p>
                           <h5 style={{ color:"#4a65d8"}}>Rp {total_bonus}</h5>
                        </Col>

                  } */}
                  {
                     status_redeem == true ? 
                        sisa_point != 0 ? 
                           <Col style={{marginLeft:"20px"}} className="col s10">
                              <p style={{marginTop:"0px", color:"#45f79e"}}>Benefit belum di Redeem</p>
                              <h5 style={{ color:"#45f79e"}}>Rp {sisa_redeem}</h5>
                           </Col>
                           :
                           <Col style={{marginLeft:"20px"}} className="col s10">
                              <p style={{marginTop:"0px", color:"red"}}>Benefit belum di Redeem</p>
                              <h5 style={{ color:"red"}}>Rp {sisa_redeem}</h5>
                           </Col>
                        :
                        sisa_point != 0 ? 
                           <Col style={{marginLeft:"20px"}} className="col s10">
                              <p style={{marginTop:"0px", color:"#45f79e"}}>Benefit belum di Redeem</p>
                              <h5 style={{ color:"#45f79e"}}>Rp {sisa_point}</h5>
                           </Col>
                           :
                           <Col style={{marginLeft:"20px"}} className="col s10">
                              <p style={{marginTop:"0px", color:"red"}}>Benefit belum di Redeem</p>
                              <h5 style={{ color:"red"}}>Rp {sisa_point}</h5>
                           </Col>
                  }
               </Row>
               <Row style={{display: "flex"}}>
                  <Col s={6} m={6} l={6} className="fadeIn" >
                     <Row style={{
                              display: "block",
                              minHeight:"80px", 
                              backgroundColor:"#c5ffdc", 
                              border: "1px solid", 
                              borderColor:"#c5ffdc",
                              borderRadius:"5px"
                           }}
                           className="align-items-top mb-m">
                              <p className="ml-s">
                                 <b>
                                    Berhasil
                                 </b>
                                    &nbsp; dikirimkan
                              </p>
                                 <h5 style={{ color:"#4a65d8"}} className="ml-s">Rp {sudah_terkirim}</h5>
                     </Row>
                  </Col>
                  <Col s={6} m={6} l={6} className="fadeIn" style={{ marginLeft:"20px"}}>
                     <Row style={{
                              minHeight:"80px", 
                              backgroundColor:"#ffb6c1", 
                              border: "1px solid", 
                              borderColor:"#ffb6c1",
                              borderRadius:"5px"
                           }} className="mb-m">
                              <p className="ml-s">
                                 <b>
                                    Belum
                                 </b>
                                    &nbsp; dikirimkan
                              </p>
                              {
                                 status_redeem == true ?
                                    <h5 style={{ color:"#4a65d8"}} className="ml-s">Rp {belum_terkirim_redeem}</h5>
                                    :
                                    <h5 style={{ color:"#4a65d8"}} className="ml-s">Rp {belum_terkirim}</h5>

                              }
                     </Row>
                  </Col>
               </Row>
               <Row>
                  {/* <Button style={{ width:"100%", marginBottom:"20px"}}className="btn btn-block">REDEEM</Button> */}
                  <Modal
                     id="modal-box"
                     trigger={
                     <Button style={{ width:"100%", marginBottom:"20px"}}className="btn btn-block ">REDEEM</Button>
                     }
                  >
                     {
                        cek_akun == true ?
                           <div className="mt-l">
                              <h4 >Nominal Rupiah</h4>
                              <div className="row">
                                 <form onSubmit={(e) => this.handleSubmitPulsa(e)}>
                                    <div className="col s12">
                                       <div className="input-field">
                                          <select
                                             name="pulsa"
                                             className="drop-down"
                                             value={this.state.total_redeem}
                                             onChange={this.handlePulsaChange}
                                          >
                                             <option value="" disabled >Pilih nominal Rupiah</option>
                                             {
                                                redeem_pulsa.map((item) => (

                                                   <option value={item.price}>Rp {item.rupiah}</option>
                                                ))
                                             }
                                          </select>
                                       </div>
                                       {
                                          status_redeem == false ?
                                             <p style={{ color:"red" }}>{message_redeem}</p> : ""
                                       }
                                       <div style={{ display:"flex", justifyContent: "center" }}>
                                          <button className="btn btn-sm">REDEEM</button>
                                       </div>
                                    </div>
                                 </form>
                              </div>
                           </div>
                        :
                           <div className="mt-m">
                              <div style={{ 
                                 display:"flex", 
                                 justifyContent: "center",
                                 }}
                              >
                                 <h4 style={{color:"red"}}>Belum Upload foto KTP!</h4>
                              </div>
                              <div className="row">
                                 <div className="mt-m" style={{ display:"flex", justifyContent: "center" }}>
                                    <a href="/upload-verifikasi-data"className="btn btn-sm">LENGKAPI DATA</a>
                                 </div>
                              </div>
                           </div>
                     }
                  </Modal>
               </Row>
               <Row>
                  <Button 
                     onClick={()=>{
                        this.props.history.push('/referral', {skema : 1})
                     }} 
                     style={{ width: "100%"}}
                     className="btn btn-block">
                        LIHAT SKEMA BENEFIT</Button>
               </Row>
               {/* <Row className="mt-xl">
                  <Col l={5} m={5} s={12} style={{ marginRight:"90px" }}>
                     <p><b>Status</b></p>
                     <div className="input-field">
								<select
									name="study"
									className="drop-down "
								>
									<option value="" disabled>Pilih Status</option>
								</select>
							</div>
                  </Col>
                  <Col l={5} m={5} s={12}>
                  <p><b>Menampilkan</b></p>
                     <div className="input-field">
								<select
									name="study"
									className="drop-down "
								>
									<option value="" disabled>Hasil</option>
								</select>
							</div>
                  </Col>
               </Row> */}
               {
                  this.state.pelanggan.length != 0 ? 
                     <Row style={{ marginTop:"50px"}}>
                        <div style={{ display:"flex", justifyContent: "center" }}>
                           <h5>Daftar Pemakai Kode Referral</h5>
                        </div>
                        <div style={{ display:"flex", justifyContent: "center" }}>
                                 <ol>
                                    {
                                       this.state.pelanggan.map(item => (

                                             <li style={{ fontSize:"20px", lineHeight:"28px" }}>{item}</li>
                                          )
                                       )
                                    }
                                    <Waypoint onEnter={this._loadMoreContent} />
                                    {!this.state.end && (
                                       <div className="center load-more mt-m">
                                          <Preloader size="medium" />
                                       </div>
                                    )}
                                 </ol>
                        </div>
                     </Row >
                  :
                  <Row style={{ marginTop:"50px"}}>
                     <div style={{ display:"flex", justifyContent: "center" }}>
                        <h5>Belum Ada Pemakai Kode Referral</h5>
                     </div>
                  </Row>
               }
            </div>
         </div>
      )
   }
}

export default DetailBenefit


// WEBPACK FOOTER //
// ./src/components/Referral/DetailBenefit.js